var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGemstone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 106,
    viewBox: "0 0 110 106",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4110_43723)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 60.5,
    r: 45.5,
    fill: "#CED2F6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0664 88.2813L109.845 19.1182L64.7658 67.6343L55.0664 88.2813Z",
    fill: "url(#paint0_linear_4110_43723)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7646 67.638L109.843 19.1152H88.0501L64.7646 67.638Z",
    fill: "url(#paint1_linear_4110_43723)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4154 19.0867L72.1699 5.63477L88.0524 19.1124L76.4154 19.0867Z",
    fill: "url(#paint2_linear_4110_43723)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9199 19.086L72.1682 5.63379L76.4137 19.086H54.9199Z",
    fill: "url(#paint3_linear_4110_43723)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.771 67.6293L76.4177 19.0869L88.0509 19.1122L64.771 67.6293Z",
    fill: "url(#paint4_linear_4110_43723)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0227 0.000976562L72.1693 5.63392L54.9199 19.0861L37.6763 5.62634L55.0227 0.000976562Z",
    fill: "url(#paint5_linear_4110_43723)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.42 19.085H54.9243L64.7694 67.6293L76.42 19.085Z",
    fill: "url(#paint6_linear_4110_43723)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1702 5.63318L55.0269 0L88.1519 0.0102147L72.1702 5.63318Z",
    fill: "url(#paint7_linear_4110_43723)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8699 5.58398L88.0552 19.1151H109.839L99.8699 5.58398Z",
    fill: "url(#paint8_linear_4110_43723)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1689 5.63318L88.0548 19.1153L99.8708 5.59286L88.1526 0.0117188L72.1689 5.63318Z",
    fill: "url(#paint9_linear_4110_43723)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0664 88.2794L9.53674e-05 19.1113L45.0791 67.6274L55.0664 88.2794Z",
    fill: "url(#paint10_linear_4110_43723)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0791 67.6302L0.000919342 19.1074H21.7936L45.0791 67.6302Z",
    fill: "url(#paint11_linear_4110_43723)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4279 19.0799L37.6733 5.62793L21.7909 19.1055L33.4279 19.0799Z",
    fill: "url(#paint12_linear_4110_43723)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9243 19.0782L37.676 5.62598L33.4306 19.0782H54.9243Z",
    fill: "url(#paint13_linear_4110_43723)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0737 67.6234L33.427 19.0811L21.7939 19.1063L45.0737 67.6234Z",
    fill: "url(#paint14_linear_4110_43723)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4242 19.0791H54.9199L45.0749 67.6234L33.4242 19.0791Z",
    fill: "url(#paint15_linear_4110_43723)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6741 5.6259L55.0254 0.00292969H21.6924L37.6741 5.6259Z",
    fill: "url(#paint16_linear_4110_43723)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97487 5.57715L21.7896 19.1083H0.00589371L9.97487 5.57715Z",
    fill: "url(#paint17_linear_4110_43723)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6753 5.62537L21.7894 19.1075L9.97341 5.58504L21.6917 0.00390625L37.6753 5.62537Z",
    fill: "url(#paint18_linear_4110_43723)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7676 67.6244L54.9225 19.082L45.0747 67.6176L55.0665 88.2796L64.7676 67.6244Z",
    fill: "url(#paint19_linear_4110_43723)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4110_43723",
    x: 9,
    y: 15,
    width: 91,
    height: 97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4110_43723"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4110_43723",
    x1: 91.59,
    y1: 16.7646,
    x2: 79.1252,
    y2: 87.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4110_43723",
    x1: 70.3015,
    y1: 61.574,
    x2: 105.787,
    y2: 18.3848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4110_43723",
    x1: 82.7596,
    y1: 5.17613,
    x2: 81.0998,
    y2: 19.2292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4110_43723",
    x1: 69.6132,
    y1: -0.156799,
    x2: 66.9163,
    y2: 24.1291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4110_43723",
    x1: 80.6853,
    y1: -1.80847,
    x2: 51.8139,
    y2: 76.2263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4110_43723",
    x1: 54.9228,
    y1: 0.000976562,
    x2: 54.9228,
    y2: 23.5879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4110_43723",
    x1: 65.6722,
    y1: 19.085,
    x2: 65.6722,
    y2: 67.6293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4110_43723",
    x1: 77.1131,
    y1: -0.191693,
    x2: 76.9722,
    y2: 5.76059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4110_43723",
    x1: 98.947,
    y1: 5.58398,
    x2: 94.6281,
    y2: 34.2492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4110_43723",
    x1: 88.3435,
    y1: -13.6703,
    x2: 88.3435,
    y2: 19.1153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4110_43723",
    x1: 18.3508,
    y1: 16.7576,
    x2: 30.756,
    y2: 87.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4110_43723",
    x1: 39.5423,
    y1: 61.5662,
    x2: 4.05638,
    y2: 18.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4110_43723",
    x1: 27.0837,
    y1: 5.1693,
    x2: 28.7434,
    y2: 19.2223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4110_43723",
    x1: 40.231,
    y1: -0.164611,
    x2: 42.928,
    y2: 24.1213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4110_43723",
    x1: 29.1594,
    y1: -1.81433,
    x2: 58.0308,
    y2: 76.2204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4110_43723",
    x1: 44.1721,
    y1: 19.0791,
    x2: 44.1721,
    y2: 67.6234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4110_43723",
    x1: 32.8005,
    y1: -0.188416,
    x2: 32.94,
    y2: 5.75313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4110_43723",
    x1: 10.8977,
    y1: 5.57715,
    x2: 15.2167,
    y2: 34.2424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4110_43723",
    x1: 21.5007,
    y1: -13.6781,
    x2: 21.5007,
    y2: 19.1075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4110_43723",
    x1: 52.6395,
    y1: 58.1317,
    x2: 35.0584,
    y2: 95.2876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemstone);
export default __webpack_public_path__ + "static/media/Gemstone.62c5014c0abf916d9960737242fc8c03.svg";
export { ForwardRef as ReactComponent };